import LegalLayout from '@/components/LegalLayout';
import { BUSINESS } from '@/lib/legal';

export default function Refunds() {
  return (
    <LegalLayout
      title="Refund & Cancellation Policy"
      intro={`How refunds, cancellations, and payment issues work for ${BUSINESS.brand} plans and top-ups.`}
    >
      <h2>Prepaid plans</h2>
      <p>
        {BUSINESS.brand} plans and top-ups are prepaid packages of tiffin credits. Tiffins you have already
        collected (used credits) are non-refundable.
      </p>

      <h2>Cancelling &amp; refunds on unused credits</h2>
      <p>
        You can stop using your subscription at any time. If you would like a refund on <strong>unused</strong>{' '}
        credits, contact us within <strong>14 days</strong> of purchase. Approved refunds are calculated as the
        amount you paid, less the value of any tiffins already collected and any non-refundable fees or applied
        discounts. Once a plan's validity period has ended, remaining credits expire and are no longer refundable.
      </p>

      <h2>Top-ups</h2>
      <p>Top-ups follow the same rules as plans: unused top-up credits may be refundable within the same window; collected tiffins are not.</p>

      <h2>Failed or incomplete payments</h2>
      <p>
        If a payment fails or is not completed, no tiffin credits are added and your plan stays pending. You will
        not be charged for a plan that was never activated.
      </p>

      <h2>Duplicate or incorrect charges</h2>
      <p>
        If you believe you were charged twice or charged incorrectly, contact us with the date and amount. Verified
        duplicate charges are refunded in full through Square to your original payment method.
      </p>

      <h2>How refunds are issued</h2>
      <p>
        Approved refunds are returned to your original Square payment method. Depending on your bank or card issuer,
        it can take several business days for the refund to appear.
      </p>

      <h2>How to request a refund or cancellation</h2>
      <p>
        Email <a href={`mailto:${BUSINESS.supportEmail}`}>{BUSINESS.supportEmail}</a> or call {BUSINESS.phone} with
        your name, Customer ID, and the payment details. We will get back to you as quickly as we can.
      </p>
    </LegalLayout>
  );
}
